import axios from "axios";
import qs from "qs";
import config from "../config";

axios.defaults.headers.common["Authorization"] = localStorage.authToken;

export default {
  taskAdd(data) {
    return axios.post(
      config.endpoint + "/task/add",
      qs.stringify({ inputs: data })
    );
  },
  taskSave(data) {
    return axios.post(config.endpoint + "/task/save", qs.stringify(data));
  },
  taskStatus(data) {
    return axios.post(config.endpoint + "/task/status", qs.stringify(data));
  },
  taskRemove(data) {
    return axios.post(config.endpoint + "/task/remove", qs.stringify(data));
  },
  tasks(data) {
    return axios.post(config.endpoint + "/tasks", qs.stringify(data));
  }
};
